import React, {FC, memo, useMemo} from 'react'
import dayjs from 'dayjs'
import classnames from 'classnames'
import { DateTimeDisplay } from './DateTimeDisplay'
import { useLivestreamStatus } from '../../hooks/useLivestreamStatus'
import './Countdown.css'
import classNames from 'classnames'
import {useStateValue} from "../state-provider/StateProvider";
import { WiStars } from "react-icons/wi";
import {FlashyBorderContainer} from "../form-components/FlashyBorderContainer";

const CountdownComponent: FC<{
}> = ({
}) => {
  const [{ translations, liveStream, isWidgetMaximized, liveStreamSubscribed }] = useStateValue()

  const { status, days, hours, minutes } = useLivestreamStatus()

  const countdown = useMemo(() => {
    return <div className={classnames("countdown-numbers-container", { "maximized" : isWidgetMaximized })}>
      <DateTimeDisplay value={days} type={translations['SubscriptionEventCountdownDaysSuffix']}/>
      <DateTimeDisplay value={hours} type={translations['SubscriptionEventCountdownHoursSuffix']}/>
      <DateTimeDisplay value={minutes} type={translations['SubscriptionEventCountdownMinutesSuffix']}/>
    </div>
  }, [days, hours, minutes, translations, isWidgetMaximized])

  const statusLabel = (() => {
    switch (status) {
      case 'live':
        return <span className="previously-live">{translations['SubscriptionFormCountdownOnlineLabel']}</span>
      case 'starting-soon':
        return <span className="previously-live">{translations['SubscriptionFormCountdownAnytimeLabel']}</span>
      case 'ended':
        return <span className="previously-live">{translations['SubscriptionFormCountdownFinishedLabel']}</span>
      case 'countdown':
        return isWidgetMaximized
          ? <FlashyBorderContainer>{countdown}</FlashyBorderContainer>
          : countdown
    }
  })()

  return (
    <>
      <div className={classNames('countdown-container', isWidgetMaximized ? 'maximized' : 'minimized')}>
        <p className="title">{liveStream?.title}</p>
        {status === 'countdown' && <p className="scheduled-at">
          {dayjs.unix(parseInt(liveStream?.scheduledAt ?? "0")).format(translations['SubscriptionEventDateTimeFormat'])}
        </p>}
        <div className="show-counter">
          {statusLabel}
        </div>

        <>
          { (status === 'countdown' || status === 'starting-soon') && (
            <div className={classnames("thank-you-label", { show: liveStreamSubscribed })}>
              <span>{translations['SubscriptionFormConfirmationLabel']}</span>
              {<WiStars size={28} />}
            </div>
          )}
        </>
      </div>
    </>
  )
}

export const Countdown = memo(CountdownComponent)
